import React, { useEffect, useState } from "react";
import { Modal, Typography, Button, Grid, List, ListItem, Collapse, styled } from "@mui/material";
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';

const TerugLeveringInschatterBox = ({ 
    dubbeleMeter, 
    setEstimatedReturns,
    estimatedReturns,
    solarPanels,
    setSolarPanels
}) => {




    useEffect(() => {
        handleSolarPanelsChange(solarPanels);
    }, [solarPanels]);


    const handleSolarPanelsChange = (value) => {
        if (value) {
            const newValue = value.trim();
            const re = /^[0-9\b]+$/;
            // If value is empty or passes the regex test, update the state
            if ((value === '' || (re.test(value) && value <= 100))) {
        
            const base = (value * 240) / 7;
            setSolarPanels(value);
            setEstimatedReturns({
                high: Math.round(base * 5),
                low: Math.round(base * 2),
                single: value * 240
            });
            }
        }
      };
    

    return (
        <Box position="relative">
          <Typography className="modal-header" variant="h6">Zonnepanelen schatting</Typography>
          <Typography className="modal-body">Voer het aantal zonnepanelen in om de teruglevering te schatten. De berekening wordt hieronder gelijk weergegeven.</Typography>
          <OutlinedInput
            type="number"
            value={solarPanels ? solarPanels : 0}
            onChange={(e) => handleSolarPanelsChange(e.target.value)}
            inputProps={{ max: 100, min: 0 }}
            endAdornment={<InputAdornment position="end">panelen</InputAdornment>}
            aria-describedby="panelen-helper-text"
          />
          <FormHelperText id="panelen-helper-text">Maximaal 100 panelen.</FormHelperText>
          <Typography variant="subtitle1" className="teruglevering-schatting">Geschatte teruglevering:</Typography>
          {dubbeleMeter ? (
            <>
              <Typography>Teruglevering hoog: <strong>{estimatedReturns.high} kWh</strong></Typography>
              <Typography>Teruglevering laag: <strong>{estimatedReturns.low} kWh</strong></Typography>
            </>
          ) : (
            <Typography>Teruglevering: <strong>{estimatedReturns.single} kWh</strong></Typography>
          )}
        </Box>
    );
    };

TerugLeveringInschatterBox.displayName = 'TerugLeveringInschatterBox';

export default TerugLeveringInschatterBox;
